export default __webpack_public_path__ + "static/ecommerce_banner-57f9d21806707e87999a612a7e89a4c8.webp";